import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api'
import { replace, push } from 'connected-react-router'

import _ from 'lodash'

const prefix = 'Motor:'
export const REQUEST_FINANCE_DATA = `${prefix} Request finance data`
export const RECEIVE_FINANCE_DATA = `${prefix} Receive finance data`
export const SAVE_WIDGET_SETTINGS = `${prefix} Save widget settings`
export const FINANCE_INFO_SHOWED = `${prefix} Finance info showed`
export const AD_REPLY_OPTION_FINANCE = `${prefix} Ad reply option finance`
export const CASH_SLIDER_CHANGED = `${prefix} Finance cash slider changed`
export const MONTHS_SLIDER_CHANGED = `${prefix} Finance months slider changed`
export const SALVAGE_VALUE_SLIDER_CHANGED = `${prefix} Finance salvage value slider changed`
export const SLIDERS_CHANGED = `${prefix} Finance sliders changed`
export const CLICKED_OPEN_FINANCE_WIDGET = `${prefix} Finance open widget`
export const CLICKED_LINK_TO_FINANCE = `${prefix} Link to finance info clicked`
export const AD_REPLY_OPTIONS_TRADE_IN = `${prefix} Ad reply option for trade in saved`
export const SAFE_PURCHASE_PARTNER_CLICKED = `${prefix} Clicked on safe purchase partner link`
export const CONTRACT_OF_SALE_CLICKED = `${prefix} Clicked on Contract Of Sale button`
export const DIRECT_PURCHASE_CLICKED = `${prefix} Clicked on open direct purchase button`
export const DIRECT_PURCHASE_EXTERNAL_CLICKED = `${prefix} Clicked on partner direct purchase button`
export const CAR_AUCTION_UPDATE_FORM_FIELD = `${prefix} CarAuction: Updated form field`
export const CAR_AUCTION_REOPEN_FORM = `${prefix} CarAuction: Reopen form`
export const CAR_AUCTION_RESET_FORM = `${prefix} CarAuction: Reset form`
export const CAR_AUCTION_API_AUTHENTICATE = `${prefix} CarAuction: Authenticate request`
export const CAR_AUCTION_API_AUTHENTICATE_SUCCESS = `${prefix} CarAuction: Authenticate request success`
export const CAR_AUCTION_API_AUTHENTICATE_FAIL = `${prefix} CarAuction: Authenticate request failure`
export const CAR_AUCTION_API_POST_FORM_DATA = `${prefix} CarAuction: Post form data`
export const CAR_AUCTION_API_RESPONSE_SUCCESS = `${prefix} CarAuction: Successful API request`
export const CAR_AUCTION_API_RESPONSE_FAIL = `${prefix} CarAuction: Failure on API request`

const requestFinanceData = createAction(REQUEST_FINANCE_DATA)
const receiveFinanceData = createAction(RECEIVE_FINANCE_DATA)
const saveWidgetSettings = createAction(SAVE_WIDGET_SETTINGS)
const financeInfoShowed = createAction(FINANCE_INFO_SHOWED)
const adReplyOptionFinance = createAction(AD_REPLY_OPTION_FINANCE)
const cashSliderChanged = createAction(CASH_SLIDER_CHANGED)
const monthsSliderChanged = createAction(MONTHS_SLIDER_CHANGED)
const salvageValueSliderChanged = createAction(SALVAGE_VALUE_SLIDER_CHANGED)
const slidersChanged = createAction(SLIDERS_CHANGED)
const clickedOpenFinanceWidget = createAction(CLICKED_OPEN_FINANCE_WIDGET)
const clickedLinkToFinance = createAction(CLICKED_LINK_TO_FINANCE)
const adReplyOptionsTradeIn = createAction(AD_REPLY_OPTIONS_TRADE_IN)
export const contractOfSaleClicked = createAction(CONTRACT_OF_SALE_CLICKED)
export const clickedOpenDirectPurchase = createAction(DIRECT_PURCHASE_CLICKED)
export const directPurchasePartnerClicked = createAction(DIRECT_PURCHASE_EXTERNAL_CLICKED)

const carAuctionReopenForm = createAction(CAR_AUCTION_REOPEN_FORM)
const carAuctionResetForm = createAction(CAR_AUCTION_RESET_FORM)
const carAuctionUpdateFormField = createAction(CAR_AUCTION_UPDATE_FORM_FIELD)

const fetchFinanceData = (externalId) => async (dispatch) => {
  dispatch(requestFinanceData())

  const response = await dispatch(api.fetch(`motor/v1/finance/${externalId}`))

  if (response.ok) {
    return dispatch(receiveFinanceData({ externalId, data: response.textOrJson }))
  }

  return dispatch(receiveFinanceData(response))
}

const closeAndSaveWidget = (widgetSettings) => async (dispatch, getState) => {
  const { pathname } = getState().router.location
  await dispatch(saveWidgetSettings(widgetSettings))
  return dispatch(replace(pathname.replace(new RegExp('/finans$'), '')))
}

const openFinanceWidget = () => (dispatch, getState) => {
  dispatch(clickedOpenFinanceWidget())
  const path = _.get(getState(), 'router.location.pathname')
  return dispatch(replace(`${path}/finans`))
}

export const openDirectPurchase = () => (dispatch, getState) => {
  dispatch(clickedOpenDirectPurchase())
  const path = _.get(getState(), 'router.location.pathname')
  return dispatch(push(`${path}/kop-bilen-direkt`))
}

const debouncedSlidersChanged = _.debounce(
  (dispatch, payload) => dispatch(slidersChanged(payload)),
  3000,
)

const slidersDidChange = (payload) => (dispatch) => debouncedSlidersChanged(dispatch, payload)

export const actionCreators = {
  fetchFinanceData,
  closeAndSaveWidget,
  financeInfoShowed,
  saveWidgetSettings,
  adReplyOptionFinance,
  openFinanceWidget,
  slidersDidChange,
  cashSliderChanged,
  monthsSliderChanged,
  salvageValueSliderChanged,
  clickedLinkToFinance,
  adReplyOptionsTradeIn,
  contractOfSaleClicked,
  openDirectPurchase,
  directPurchasePartnerClicked,
  carAuctionUpdateFormField,
  carAuctionReopenForm,
  carAuctionResetForm,
}
